module.exports = __webpack_public_path__ + "../resources/images/readingPaneOffLarge-448538943dd7b6265ded93092c51df3e.svg";